<template>
	<div class="flex snap-x scroll-pl-4 overflow-x-scroll">
		<PagePadding class="mx-auto inline-flex items-center gap-1.5">
			<slot />
		</PagePadding>
	</div>
</template>
<script setup lang="ts">
import PagePadding from './PagePadding.vue'
</script>
